/**
 * Application constants.
 *
 * Static values shared across the application.
 */

export const APP_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  STORAGE_KEYS: {
    THEME: 'platform.theme',
    AUTH_TOKEN: 'platform.auth-token',
  },
} as const;

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const;

export const ANIMATION_DURATIONS = {
  fast: 150,
  normal: 200,
  slow: 300,
} as const;
